import React from 'react';
import GenerationHistory from '@pages-clean/shared/generation-history/generation-history';
import Constants from '@utils/constants';
import { LoggedInPageProps } from '@config/routes/interfaces';

const SubjectMonitoringGenerationHistory = ({ organisationKey, study, user }: LoggedInPageProps) => {
    return (
        <GenerationHistory
            module={Constants.Modules.SM}
            orgKey={organisationKey!}
            studyId={study!.id as string}
            user={user}
        />
    );
};
export default SubjectMonitoringGenerationHistory;
